import React, {useState} from "react";
import NavLinks from "./NavLinks";
import Logo from "./Logo";
import SelectLanguage from "./SelectLanguage";
import Button from "../button/Button";
import MenuBtn from "./MenuBtn";
import MenuMobile from "./MenuMobile";
import {useLanguage} from "../../hooks/LanguageContext";
import {useNavigate} from "react-router-dom";

// Translation data
const translations = {
	en: {
		links: [
			{ href: "/", text: "Home" },
			{ href: "/about", text: "About Us" },
			{ href: "/services", text: "Services" },
			{ href: "/partners", text: "Partners" },
			/*{ href: "/tracking", text: "Tracking" },
			{ href: "/booking", text: "Booking" },*/
			{ href: "/branches", text: "Branches" },
	/*		{ href: "/careers", text: "Careers" },*/
			{ href: "/contactus", text: "Contact Us" },
		],
		login: "Login",
	},
	ar: {
		links: [
			{ href: "/", text: "الرئيسية" },
			{ href: "/about", text: "من نحن" },
			{ href: "/services", text: "خدماتنا" },
			{ href: "/partners", text: "شركاؤنا" },
/*			{ href: "/tracking", text: "التتبع" },
			{ href: "/booking", text: "الحجز" },*/
			{ href: "/branches", text: "فروعنا" },
/*			{ href: "/careers", text: "الوظائف" },*/
			{ href: "/contactus", text: "تواصل معنا" },
		],
		login: "تسجيل دخول",
	},
};

const Navbar = () => {
	const { language } = useLanguage(); // Get the current language
	const [activeLink, setActiveLink] = useState("");
	const [openMenu, setOpenMenu] = useState(false);
	const navigate = useNavigate();
	const handleToggleMenu = () => {
		setOpenMenu(!openMenu);
	};

	const handleLinkClick = (href) => {
		setActiveLink(href);
	};

	// Get translations for the current language
	const { links, login } = translations[language];

	return (
		<nav className="container max-w-screen-md md:absolute lg:max-w-screen-xl top-0 md:top-[55px] left-0 md:left-1/2 md:-translate-x-1/2 h-[100px] flex justify-between items-center py-0 md:px-[30px] px-2 bg-white md:rounded-[10px] border-b-[3px] border-primary-700 z-50">
			<Logo />
			<NavLinks
				links={links}
				activeLink={activeLink}
				handleLinkClick={handleLinkClick}
			/>

			<section className="md:flex hidden items-center gap-x-2 lg:gap-x-6">
				<SelectLanguage />
				<Button onClick={() => navigate('/login')}>{login}</Button>
			</section>

			<div className="md:hidden flex items-start gap-4">
				<SelectLanguage />
				<MenuBtn onClick={handleToggleMenu} />
			</div>
			<MenuMobile
				links={links}
				openMenu={openMenu}
				activeLink={activeLink}
				onClick={handleToggleMenu}
				handleLinkClick={handleLinkClick}
			/>
		</nav>
	);
};

export default Navbar;
